import Table, { compareStrings } from 'apollo-react/components/Table';
import { React, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { API_URL, OBJ_ROLE, SYS_ROLE } from '../common/Constants';
import Loading from '../common/Loading';
import './FolderManagement.scss';
import Button from 'apollo-react/components/Button';
import Plus from 'apollo-react-icons/Plus';
import folderManagementData from '../json/folderManagementData.json';
import folderManagementLinkData from '../json/folderManagementLinkData.json'
import { getApi, getFuncroleFlg, setURL, redirectToLogin } from '../common/Utils';
import { Link } from 'apollo-react';
import { format } from 'date-fns';
import funcroleData from '../json/funcroleData.json';
// 検索用のコンポーネントを追加
import TextField from 'apollo-react/components/TextField';
import Search from 'apollo-react-icons/Search';

/**
 * ファイル管理
 */
function FolderManagement() {
    const location = useLocation();
    const [t, i18n] = useTranslation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const DIALOG_STATUS = {
        NO_DIALOG: '0',
        OK_DIALOG: '1',
        DETAIL_DIALOG: '2',
        DELETE_CONFIRM_DIALOG: '3',
    };
    const [dialogStatus, setDialogStatus] = useState(DIALOG_STATUS.NO_DIALOG);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogContent, setDialogContent] = useState('');
    const [detailContent, setDetailContent] = useState('');
    
    // 権限設定変更リンククリック権限
    const [changeFolderLinkAuthList, setChangeFolderLinkAuthList] = useState(false);
    // フォルダ追加ボタン権限
    const [createFolderBtnAuthFlg, setCreateFolderBtnAuthFlg] = useState(false);
    // 一覧の表示リスト権限
    const [folderManagementList, setFolderManagementList] = useState([]);
    // フィルタリング前の元データ
    const [originalFolderManagementList, setOriginalFolderManagementList] = useState([]);

    // ユーザー情報格納用(サービス管理者対応)
    const [folderManagementLinkList,setFolderManagementLinkList] = useState([]);

    const [usrroleCode, setUsrroleCode] = useState('');

    // 検索条件のstate
    const [searchServiceName, setSearchServiceName] = useState('');
    const [searchCompanyName, setSearchCompanyName] = useState('');

    // フォルダ管理のサービス名のリンク処理
    const ServiceNameCell = ({ row }) => {
        let linkauth = false;
        const isInFolderManagementLinkList = folderManagementLinkList.some(
            (item) => item.auditCode === row.auditCode
        );

        if(usrroleCode === '001')
        {
            if(isInFolderManagementLinkList == true)
            {
                linkauth = true;
            }
        }
        else
        {
            linkauth = changeFolderLinkAuthList;
        }

        return (
            <Link
                disabled={!linkauth}
                onClick={() => handleLinkClick(row)}
            >
                {row.auditName}
            </Link>
        );
    };

    // 各日付データをjavascript側で指定の書式(yyyy/mm/dd)へフォーマット変換
    const RecIDateCell = ({ row }) => {
        const ret = row.recIdate !== null ? format(new Date(row.recIdate), 'yyyy/MM/dd') : '';
        return ret;
    };
    const RecDateCell = ({ row }) => {
        const ret = row.recDate !== null ? format(new Date(row.recDate), 'yyyy/MM/dd') : '';
        return ret;
    };

    // 画面に表示するためのカラム設定
    const columns = [
        {
            header: t('service'),
            accessor: 'auditName',
            customCell: ServiceNameCell,
            sortFunction: compareStrings,
        },
        {
            header: t('org'),
            accessor: 'comp',
            sortFunction: compareStrings,
        },
        {
            header: t('folderCount'),
            accessor: 'folderCount',
            sortFunction: compareStrings,
        },
        {
            header: t('fileCount'),
            accessor: 'fileCount',
            sortFunction: compareStrings,
        },
        {
            header: t('usrCount'),
            accessor: 'usrCount',
            sortFunction: compareStrings,
        },
        {
            header: t('folderOwnersName'),
            accessor: 'folderOwnersName',
            sortFunction: compareStrings,
        },
        {
            header: t('registrationDate'),
            accessor: 'recIdate',
            customCell: RecIDateCell,
            sortFunction: compareStrings,
        },
        {
            header: t('lastUpdated'),
            accessor: 'recDate',
            customCell: RecDateCell,
            sortFunction: compareStrings,
        }
    ];

    /**
     * 検索処理
     */
    const handleSearch = () => {
        let filteredList = [...originalFolderManagementList];

        // サービス名でフィルタリング
        if (searchServiceName) {
            filteredList = filteredList.filter(item => 
                item.auditName && item.auditName.toLowerCase().includes(searchServiceName.toLowerCase())
            );
        }

        // 企業名でフィルタリング
        if (searchCompanyName) {
            filteredList = filteredList.filter(item => 
                item.comp && item.comp.toLowerCase().includes(searchCompanyName.toLowerCase())
            );
        }

        setFolderManagementList(filteredList);
    };

    /**
     * クリアボタン処理
     */
    const handleClear = () => {
        setSearchServiceName('');
        setSearchCompanyName('');
        setFolderManagementList(originalFolderManagementList);
    };

    /**
     * フォルダ追加ボタン押下時の処理
     */
    const createFolderBtnClick = () => {
        // フォルダ追加画面へ遷移
        navigate('/createfolder');
    };

    /**
     * フォルダリスト取得APIの成功時の処理
     * @param {object} response フォルダリスト取得APIのレスポンス
     */
    function searchApiSuccess(response) {
        setFolderManagementList(response);
        setOriginalFolderManagementList(response); // 元データを保存
    };

    /**
     * フォルダリスト取得APIの失敗時の処理
     * @param {object} error エラーオブジェクト
     */
    function searchApiError(error) {
        const detailErrorMessage = 'フォルダリスト取得処理でエラーが発生しました。\n(An error occurred during the folder list acquisition process.)';
        commonError(error, detailErrorMessage);

        //認証期限切れの場合は再ログイン
        redirectToLogin();
    };

    /**
     * サービス管理者対応用の取得APIの成功時の処理
     * @param {object} response フォルダリスト取得APIのレスポンス
     */
    function folderManagementLinkApiSuccess(response) {
        setFolderManagementLinkList(response);
    };

    /**
     * サービス管理者取得APIの失敗時の処理
     * @param {object} error エラーオブジェクト
     */
    function folderManagementLinkApiError(error) {
        const detailErrorMessage = 'サービス管理者情報取得処理でエラーが発生しました。\n(An error occurred during the folder manager list acquisition process.)';
        commonError(error, detailErrorMessage);

        //認証期限切れの場合は再ログイン
        redirectToLogin();
    };

    /**
     * 共通エラー処理
     * @param {object} error エラーオブジェクト
     * @param {string} detailErrorMessage 詳細ダイアログに設定するエラーメッセージ
     */
    const commonError = (error, detailErrorMessage) => {
        if (error.name === 'MaintenanceApiError') {
            navigate('/', { state: { maintenanceFlg: true, }});
        } else if (error.name === 'CustomApiError') {
            const message = error.message;
            setDialogStatus(DIALOG_STATUS.OK_DIALOG);
            setDialogOpen(true);
            setDialogContent(message);
        } else {
            setDialogStatus(DIALOG_STATUS.DETAIL_DIALOG);
            setDialogOpen(true);
            setDialogContent(detailErrorMessage);
            setDetailContent(error.stack);
        }
    };

    /**
     * サービス名のリンク押下時の処理
     * @param {object} row 選択している行の情報
     */
    const handleLinkClick = (row) => {
        const param = {
            auditName: row.auditName,
            auditCode: row.auditCode,
            orgName: row.comp,
            orgLevel0Code: row.orgLevel0Code
        };
        // 権限設定へ遷移
        navigate('/settingpermission',{state:param})
    };

    /**
     * 機能権限情報取得APIの成功時の処理
     */
    function funcroleApiSuccess(response) {
        localStorage.setItem('funcroleList', JSON.stringify(response));
    };

    /**
     * 機能権限情報取得APIの失敗時の処理
     * @param {object} error エラーオブジェクト
     */
    function funcroleApiError(error) {
        const detailErrorMessage = '機能権限情報取得処理でエラーが発生しました。\n(An error occurred during the function authority information acquisition process.)';
        commonError(error, detailErrorMessage);
        //認証期限切れの場合は再ログイン
        redirectToLogin();
    };

    // すべての処理が終了後に呼び出される処理
    useEffect(() => {
        (async () => {
            if (window.localStorage.getItem(['token']) === null) {
                navigate('/')
                return;
            }

            // フォルダ一覧取得API
            const url = setURL(API_URL.FOLDER_LIST);
            const getApiParam = {
                url: url,
                sysRole: SYS_ROLE.FOLDER_MANAGEMENT,
                success: searchApiSuccess,
                error: searchApiError,
                json: folderManagementData
            }
            await getApi(getApiParam);

            // サービス管理者のリンク権限取得
            const managementlinkurl = setURL(API_URL.FOLDER_MANAGEMENT_LINK);
            const getManageApiParam = {
                url: managementlinkurl,
                sysRole: SYS_ROLE.FOLDER_MANAGEMENT,
                success: folderManagementLinkApiSuccess,
                error: folderManagementLinkApiError,
                json: folderManagementLinkData
            }
            await getApi(getManageApiParam);

            // 機能権限情報取得API
            const urlFuncrole = setURL(API_URL.FUNCROLE);
            const getFuncroleApiParam = {
                url: urlFuncrole,
                sysRole: SYS_ROLE.PORTAL,
                success: funcroleApiSuccess,
                error: funcroleApiError,
                json: funcroleData,
            }
            await getApi(getFuncroleApiParam);

            // フォルダ追加ボタンの権限フラグを設定
            const createFolderBtnAuthFlg = getFuncroleFlg(SYS_ROLE.FOLDER_MANAGEMENT, OBJ_ROLE.CREATE_FOLDER_BTN)
            setCreateFolderBtnAuthFlg(createFolderBtnAuthFlg);

            // 権限設定リンクの権限フラグを設定
            const folderManagementLinkAuthList = getFuncroleFlg(SYS_ROLE.FOLDER_MANAGEMENT, OBJ_ROLE.SETTING_PERMISSION_LINK);
            setChangeFolderLinkAuthList(folderManagementLinkAuthList);

            // 現在のログインユーザーの権限を取得
            const usrroleCodeData = JSON.parse(localStorage.getItem('usrroleCode'));
            const usrroleCode = usrroleCodeData.usrroleCode;
            setUsrroleCode(usrroleCode);

            setIsLoading(false);
        })();
    }, []);

    if (isLoading) {
        // ロード中の場合はローディング画面
        return (
            <Loading />
        );
    } else {
        return(
            <div className="folderManagement">
                {/* 検索条件エリア */}
                <div className="search-area">
                    <TextField
                        label={t('service')}
                        value={searchServiceName}
                        onChange={(e) => setSearchServiceName(e.target.value)}
                    />
                    <TextField
                        label={t('org')}
                        value={searchCompanyName}
                        onChange={(e) => setSearchCompanyName(e.target.value)}
                    />
                    <div className="search-buttons">
                        <Button
                            variant="primary"
                            size="small"
                            onClick={handleSearch}
                        >
                            <Search /> {t('search')}
                        </Button>
                        <Button
                            variant="primary"
                            size="small"
                            onClick={handleClear}
                        >
                            {t('clear')}
                        </Button>
                    </div>
                </div>
                <div className="buttons">
					<Button
						variant="primary"
						size="small"
						className="createFolderBtn"
						status="success"
						onClick={createFolderBtnClick}
						disabled={!createFolderBtnAuthFlg}
					>
						<Plus />{t('createFolder')}
					</Button>
				</div>
                <div className='table-wrap'>
                    <Table
                    className="folderList"
                    columns={columns}
                    rowId="id"
                    rows={folderManagementList}
                    rowsPerPageOptions={[10, 50, 100, 'All']}
                    rowProps={{ hover: false }}
                    tablePaginationProps={{
                        labelDisplayedRows: ({ from, to, count }) => `全${count}件`,
                        truncate: true,
                    }}
                    emptyProps={{ text: t('message.1000100') }}
                    />
                </div>
            </div>
        );
    }
}

export default FolderManagement;